import { useEffect, useState } from 'react';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import Form from 'react-bootstrap/Form';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Alert, Button as RBButton, Col, Row } from 'react-bootstrap';
import { useAuth } from '../../../hooks/useAuth';

function UploadSale() {
  const { user } = useAuth();
  const [file, setFile] = useState('');
  const [importedData, setImportedData] = useState('');
  const [loading, setLoading] = useState(false);
  const [alertSuccessIsVisible, setAlertSuccessIsVisible] = useState(false);
  const [globalFilter, setGlobalFilter] = useState('');
  const [filters, setFilters] = useState({
    'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
    'orderEntityId': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'externalOrderId': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'driverName': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'clientName': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'clientId': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'phoneNumber': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'email': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'destiny': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'flightNo': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'reference': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'serviceType': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'departureTime': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'vehicleType': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'vehicleNo': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'passengerNo': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'zone': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'price': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.GREATER_THAN }] },
    'paymentType': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'agreement': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'agreementPrice': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'paymentStatus': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'operationalStatus': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'driverComment': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'saleOrigin': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'invoiceId': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },
    'invoiceNo': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] }
  });

  // console.info('[UploadSale] User:', user);

  useEffect(() => {    
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  }, []);

  const onUploadClick = () => {
    setImportedData([]);
    resetAlerts();
    upload();
    resetFile();
  };

  const reset = () => {
    document.getElementById("fileInput").value = "";
  };

  const upload = () => {    
    setLoading(true);
    let file = document.querySelector('input[type="file"]')
    var data = new FormData();
    data.append('file', file.files[0]);
    fetch(`${process.env.REACT_APP_API_URL}/order/synchronizeOrder?userId=${user.userId}`, {
      method: 'POST',      
      body: data,
    }).then(response => response.json()).then(data => {
      if (data.responseCode === 'OK') {
        setAlertSuccessIsVisible(true);
        setImportedData(data.responseObject);
        reset();
        setLoading(false);
      } else {
        console.error('UloadSale: upload: error');
        setLoading(false);
      }
    });
  }

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    const _filters = { ...filters };
    _filters['global'].value = value;
    setFilters(_filters);
    setGlobalFilter(value);
  }

  const onFileInputChange = (e) => {
    setAlertSuccessIsVisible(false);
    setFile(e.target.files[0].name)
  };

  const resetFile = () => {
    setFile('');
  };

  const resetAlerts = () => {
    setAlertSuccessIsVisible(false);
  };

  const headerTemplate = (
    <>
      <Row>
        <Col>
          <span className="p-input-icon-left">
            <i className="pi pi-filter" />
            <InputText
              placeholder="Filtrar"
              value={globalFilter}
              onChange={onGlobalFilterChange} />
          </span>
        </Col>
      </Row>
    </>
  );

  const dataTableTemplate = (
    <>
      <div className="card">
        <DataTable
          className=""
          showGridlines
          stripedRows
          size="small"
          responsiveLayout="scroll"
          emptyMessage="No se importaron registros"
          value={importedData}
          resizableColumns
          columnResizeMode="fit"
          header={headerTemplate}
          filters={filters}
          filterDisplay="menu"
          loading={loading}
          globalFilterFields={[
            'global',
            'orderEntityId',
            'externalOrderId',
            'driverName',
            'clientName',
            'clientId',
            'phoneNumber',
            'email',
            'destiny',
            'flightNo',
            'reference',
            'serviceType',
            'departureTime',
            'vehicleType',
            'vehicleNo',
            'passengerNo',
            'zone',
            'price',
            'paymentType',
            'agreement',
            'agreementPrice',
            'paymentStatus',
            'operationalStatus',
            'driverComment',
            'saleOrigin',
            'invoiceId',
            'invoiceNo',
          ]}>
          <Column
            field='orderEntityId'
            header='Consecutivo'
            className='app-w-200-px text-end'
            filter
            filterPlaceholder="Buscar por consecutivo"
            sortable />
          <Column
            field='externalOrderId'
            header='No. servicio'
            className='app-w-200-px text-start'
            filter
            filterPlaceholder="Buscar por no. servicio"
            sortable />
          <Column
            field='driverName'
            header='Conductor'
            className='app-w-200-px text-start'
            filter
            filterPlaceholder="Buscar por conductor"
            sortable />
          <Column
            field='clientName'
            header='Cliente'
            className='app-w-200-px text-start'
            filter
            filterPlaceholder="Buscar por cliente"
            sortable />
          <Column
            field='clientId'
            header='ID de cliente'
            className='app-w-200-px text-end'
            filter
            filterPlaceholder="Buscar por ID de cliente"
            sortable />
          <Column
            field='phoneNumber'
            header='Teléfono móvil'
            className='app-w-200-px text-start'
            filter
            filterPlaceholder="Buscar por teléfono móvil"
            sortable />
          <Column
            field='email'
            header='Correo electrónico'
            className='app-w-200-px text-start'
            filter
            filterPlaceholder="Buscar por correo electrónico"
            sortable />
          <Column
            field='destiny'
            header='Dirección'
            className='app-w-200-px text-start'
            filter
            filterPlaceholder="Buscar por dirección"
            sortable />
          <Column
            field='flightNo'
            header='Vuelo'
            className='app-w-200-px text-start'
            filter
            filterPlaceholder="Buscar por vuelo"
            sortable />
          <Column
            field='reference'
            header='Instrucciones y referencias'
            className='app-w-200-px text-start'
            filter
            filterPlaceholder="Buscar por instrucciones y referencias"
            sortable />
          <Column
            field='serviceType'
            header='Tipo de servicio'
            className='app-w-200-px text-start'
            filter
            filterPlaceholder="Buscar por tipo de servicio"
            sortable />
          <Column
            field='departureTime'
            header='Fecha y hora de partida'
            className='app-w-200-px text-start'
            filter
            filterPlaceholder="Buscar por fecha y hora de partida"
            sortable />
          <Column
            field='vehicleType'
            header='tipo de vehículo'
            className='app-w-200-px text-start'
            filter
            filterPlaceholder="Buscar por tipo de vehículo"
            sortable />
          <Column
            field='vehicleNo'
            header='Vehículo'
            className='app-w-200-px text-start'
            filter
            filterPlaceholder="Buscar por vehículo"
            sortable />
          <Column
            field='passengerNo'
            header='Número de pasajeros'
            className='app-w-200-px text-end'
            filter
            filterPlaceholder="Buscar por número de pasajeros"
            sortable />
          <Column
            field='zone'
            header='Zona'
            className='app-w-200-px text-start'
            filter
            filterPlaceholder="Buscar por zona"
            sortable />
          <Column
            field='price'
            header='Precio'
            className='app-w-200-px text-end'
            filter
            filterPlaceholder="Buscar por precio"
            sortable />
          <Column
            field='paymentType'
            header='Forma de pago'
            className='app-w-200-px text-start'
            filter
            filterPlaceholder="Buscar por forma de pago"
            sortable />
          <Column
            field='agreement'
            header='Convenio alias'
            className='app-w-200-px text-start'
            filter
            filterPlaceholder="Buscar por convenio alias"
            sortable />
          <Column
            field='agreementPrice'
            header='Precio convenio'
            className='app-w-200-px text-start'
            filter
            filterPlaceholder="Buscar por precio convenio"
            sortable />
          <Column
            field='paymentStatus'
            header='Estatus de pago'
            className='app-w-200-px text-start'
            filter
            filterPlaceholder="Buscar por estatus de pago"
            sortable />
          <Column
            field='operationalStatus'
            header='Estatus operativo'
            className='app-w-200-px text-start'
            filter
            filterPlaceholder="Buscar por estatus operativo"
            sortable />
          <Column
            field='driverComment'
            header='Comentarios del conductor'
            className='app-w-200-px text-start'
            filter
            filterPlaceholder="Buscar por comentarios del conductor"
            sortable />
          <Column
            field='saleOrigin'
            header='Canal de venta'
            className='app-w-200-px text-start'
            filter
            filterPlaceholder="Buscar por canal de venta"
            sortable />
          <Column
            field='invoiceId'
            header='ID de factura'
            className='app-w-200-px text-start'
            filter
            filterPlaceholder="Buscar por ID de factura"
            sortable />
          <Column
            field='invoiceNo'
            header='Folio de factura'
            className='app-w-200-px text-start'
            filter
            filterPlaceholder="Buscar por folio de factura"
            sortable />
        </DataTable>
      </div>
    </>
  );


  const viewTemplate = (
    <>
      <article>
        <Row>
          <Col>
            <h1 className='app-font'>
              Subir venta
            </h1>
          </Col>
        </Row>
        <Row>
          <Col>
            <Alert
              key='success'
              variant='success'
              hidden={!alertSuccessIsVisible}>
              La venta se subió correctamente!
            </Alert>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6}>
            <Form.Group controlId="formFile">
              <Form.Label>Selecciona el archivo</Form.Label>
              <Form.Control
                id="fileInput"
                type="file"
                label={file}
                onChange={onFileInputChange} />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col>
            <RBButton
              className='mt-2 mb-2'
              variant="primary"
              size="lg"
              onClick={onUploadClick}
              disabled={file === ''}>
              Subir
            </RBButton>
          </Col>
        </Row>
        <Row>
          <Col>
            {dataTableTemplate}
          </Col>
        </Row>
      </article>
    </>
  );

  return (
    <>
      {viewTemplate}
    </>
  );
}

export default UploadSale;